import { render, staticRenderFns } from "./AppTablePagination.vue?vue&type=template&id=7572287c"
import script from "./AppTablePagination.vue?vue&type=script&lang=js"
export * from "./AppTablePagination.vue?vue&type=script&lang=js"
import style0 from "./AppTablePagination.vue?vue&type=style&index=0&id=7572287c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports